import React, { useState } from 'react';

const FiveStarReviewResponse = ({ question, response, onUpdate }) => {
    const [hoveredStar, setHoveredStar] = useState(0);

    const handleStarClick = (rating) => {
        onUpdate(question.id, rating.toString());
    };

    const currentRating = response?.value ? parseInt(response.value) : 0;

    const getStarColor = (star) => {
        const isActive = hoveredStar >= star || (hoveredStar === 0 && currentRating >= star);
        return isActive ? '#FFC107' : '#E0E0E0';
    };

    return (
        <div className="d-flex align-items-center gap-1">
            <div
                className="d-flex gap-1"
                onMouseLeave={() => setHoveredStar(0)}
                style={{ cursor: 'pointer' }}
            >
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        type="button"
                        onClick={() => handleStarClick(star)}
                        onMouseEnter={() => setHoveredStar(star)}
                        className="btn p-0 border-0 bg-transparent"
                        style={{
                            fontSize: '2rem',
                            lineHeight: '1',
                            transition: 'all 0.2s ease-in-out',
                            color: getStarColor(star),
                            transform: (hoveredStar >= star || (hoveredStar === 0 && currentRating >= star)) ? 'scale(1.1)' : 'scale(1)',
                        }}
                        aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
                    >
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                                filter: (hoveredStar >= star || (hoveredStar === 0 && currentRating >= star))
                                    ? 'drop-shadow(0 2px 4px rgba(255, 193, 7, 0.4))'
                                    : 'none',
                            }}
                        >
                            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                        </svg>
                    </button>
                ))}
            </div>
            {currentRating > 0 && (
                <span className="ms-2 text-muted" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                    {currentRating} / 5
                </span>
            )}
        </div>
    );
};

export default FiveStarReviewResponse;
